export default __webpack_public_path__ + "static/media/antonio.128f4c3b.png";